import gql from 'graphql-tag';

import { orderFragment } from '../fragments/order-fragment';

export const startGameOrderMutation = gql`
  mutation StartGameOrder(
    $items: [OrderItemInput!]
    $timeZone: String!
    $userId: Int!
  ) {
    startOrder: startOrderV2(
      resetOrder: true
      timeZone: $timeZone
      userId: $userId
      items: $items
    ) {
      ...OrderFragment
    }
  }

  ${orderFragment}
`;
